import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Shield, Eye, EyeOff } from "lucide-react";

import { acceptSession } from "../utils/authSession";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/admin/login`,
        { email, password }
      );
      
      localStorage.setItem("mygoal-admin", JSON.stringify(acceptSession(response.data)));
      toast.success("Welcome, Admin");
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center p-4">
      <div className="w-full max-w-sm md:max-w-md">
        <div className="text-center mb-6 md:mb-8">
          <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-3 md:mb-4 rounded-2xl bg-gradient-to-br from-red-500 to-orange-500 flex items-center justify-center">
            <Shield className="w-7 h-7 md:w-8 md:h-8 text-white" />
          </div>
          <h1 className="text-xl md:text-2xl font-bold text-white">Admin Access</h1>
          <p className="text-white/40 text-xs md:text-sm mt-1">Restricted Area</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-3 md:space-y-4">
          <div>
            <label className="block text-white/60 text-xs md:text-sm mb-1.5 md:mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 md:px-4 py-2.5 md:py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:border-red-500/50 focus:outline-none text-sm md:text-base"
              placeholder="admin@mygoal.com"
              required
            />
          </div>

          <div>
            <label className="block text-white/60 text-xs md:text-sm mb-1.5 md:mb-2">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 md:px-4 py-2.5 md:py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:border-red-500/50 focus:outline-none pr-11 text-sm md:text-base"
                placeholder="••••••••"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/60"
              >
                {showPassword ? <EyeOff className="w-4 h-4 md:w-5 md:h-5" /> : <Eye className="w-4 h-4 md:w-5 md:h-5" />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 md:py-3 bg-gradient-to-r from-red-500 to-orange-500 text-white font-semibold rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50 text-sm md:text-base"
          >
            {loading ? "Authenticating..." : "Access Dashboard"}
          </button>
        </form>

        <p className="text-center text-white/20 text-xs mt-6 md:mt-8">
          Unauthorized access is prohibited
        </p>
      </div>
    </div>
  );
};

export default AdminLoginPage;
